import styled from 'styled-components';

export const TwoColumnsDiv = styled.div`
	display: grid;
	grid-template-columns: 1fr max-content;
	gap: 5px;
`;

export const CardControllers = styled.div`
	text-align: right;
	min-width: 0;
	overflow: hidden;
`;

export const OpenLayerCTAContainer = styled.div`
	align-self: start;
	transition: opacity 0.35s ease;
`;
